import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";

const classes = {
  root: {
    flexGrow: 1,
  },
  paper: {
    height: 600,
    width: 1000,
    padding: 20,
    textAlign: "center",
    fontFamily: "Roboto",
  },
};

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      style={classes.root}
      {...other}
    >
      {value === index && (
        <Grid container spacing={3}>
          <Grid item xs={12} alignItems="stretch">
            <div style={classes.paper}>{children}</div>
          </Grid>
        </Grid>
      )}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default TabPanel;
